// frontend/src/components/pages/CalendarPage.js
import { useState } from 'react';
import TradingCalendar from '../calendars/TradingCalendar';
import CalendarInputForm from '../calendars/CalendarInputForm';

export default function CalendarPage() {
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSelectEvent = (event) => {
    // TradingCalendar에서 전달한 이벤트 정보를 그대로 저장
    setSelectedEvent(event);
  };

  const handleClearSelected = () => {
    setSelectedEvent(null);
  };

  const handleChanged = () => {
    // 생성/수정/삭제 후 캘린더 새로고침 트리거
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <div>
      <CalendarInputForm
        selectedEvent={selectedEvent}
        onClearSelected={handleClearSelected}
        onChanged={handleChanged}
      />
      <TradingCalendar
        onSelectEvent={handleSelectEvent}
        refreshKey={refreshKey}
      />
    </div>
  );
}
